import { apiRequest } from "./queryClient";

type LogoutResponse = {
  redirectUrl?: string | null;
};

/**
 * Clears the application session, then completes provider logout for OIDC
 * users. Password users return to the caller's local fallback route.
 */
export async function logoutAndRedirect(localFallback: string): Promise<void> {
  const response = await apiRequest("POST", "/api/auth/logout");
  const { redirectUrl } = await response.json() as LogoutResponse;
  window.location.assign(redirectUrl || localFallback);
}